import jsC8 from "jsc8";
import config from "./serviceConfig";

const jsc8Client = new jsC8({
    url: config.gdnURL,
    apiKey: config.apiKey,
});

export const listSecurities = async () => {
    let response;
    try {
        response = await jsc8Client.executeRestql(config.listSecuritiesQueryName);
    } catch (error) {
        console.error(error);
    }
    return response;
};

export const listTopNSecurities = async (sentimentType, bindParams) => {
    let response;
    let queryName;

    switch (sentimentType.toLowerCase()) {
        case "negative":
            queryName = config.listTopNegativeSecuritiesQueryName;
            break;

        case "neutral":
            queryName = config.listTopNeutralSecuritiesQueryName;
            break;

        case "positive":
            queryName = config.listTopPositiveSecuritiesQueryName;
            break;
    }

    try {
        response = await jsc8Client.executeRestql(queryName, bindParams);
    } catch (error) {
        console.error(error);
    }
    return response;
};
